import React, { useEffect, useRef, useState } from 'react';
import './qualification-side-scroll.scss';

export default function QualificationSideScroll({ children, automationIdPrefix }) {
  const sideScrollRef = useRef();
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const childrenArray = Array.from(sideScrollRef.current.children);

    const options = {
      threshold: 0.9,
    };

    const entriesCallBack = (entries) =>
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const idx = childrenArray.indexOf(entry.target) || 0;
          setScrollProgress(idx);
        }
      });

    const observer = new IntersectionObserver(entriesCallBack, options);

    childrenArray.forEach((child) => observer.observe(child));
    return () => childrenArray.forEach((child) => observer.unobserve(child));
  }, []);

  return (
    <div className="QualificationSideScroll has-margin-bottom-3 has-mobile-margin-bottom-0">
      <div ref={sideScrollRef} className="qualification-side-scroll">
        {children}
      </div>
      <div className="is-hidden-tablet has-margin-bottom-3">
        <div className="scroll-progress-container">
          <div className="scroll-progress">
            {children.map((_child, index) => (
              <div
                key={index}
                className={`scroll-progress-bullet ${scrollProgress === index ? 'active' : ''}`}
                automationid={`${automationIdPrefix}_Scroll_Progress_Bullet_${index}`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
